import { storage } from '@/config'

export function setStorage (key, value) {
  if (!storage.has(key)) {
    throw new TypeError(`${key} is not in config`)
  }
  localStorage.setItem(key, value)
}

export function getStorage (key) {
  if (!storage.has(key)) {
    throw new TypeError(`${key} is not in config`)
  }
  return localStorage.getItem(key)
}

export function clearStorage () {
  for (let key of storage.keys()) {
    localStorage.removeItem(key)
  }
}
export function getUriParam (url) {
  if (!url) {
    url = location.search // 获取url中"?"符后的字串
  }
  var theRequest = {}
  if (url.indexOf('?') !== -1) {
    var str = url.split('?')[1]
    var strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}

export function parseTime (time, cFormat) {
  var date = new Date()
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }

  const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return timeStr
  // return y + '-' + m + '-' + d + ' '
}
